module.exports = __webpack_public_path__ + "media/e-2.a12dffdd.mp3";